"use strict";
exports.__esModule = true;
exports.AllAvailableNonSaleVariants = exports.AllAvailableSaleVariants = exports.AllNonSaleVariants = exports.AllSaleVariants = exports.AllAvailableVariants = exports.AllVariants = void 0;
//Returns all the variants for the product
var AllVariants = function (product, template) {
    return product.variants;
};
exports.AllVariants = AllVariants;
// Returns all variants for the product that are available
var AllAvailableVariants = function (product, template) {
    return product.variants.filter(function (variant) { return template.isVariantAvailable(variant); });
};
exports.AllAvailableVariants = AllAvailableVariants;
//Returns all the variants for the product that are on sale
var AllSaleVariants = function (product, template) {
    return product.variants.filter(function (variant) { return template.isVariantOnSale(variant); });
};
exports.AllSaleVariants = AllSaleVariants;
//Returns all the variants for the product that are not on sale
var AllNonSaleVariants = function (product, template) {
    return product.variants.filter(function (variant) { return !template.isVariantOnSale(variant); });
};
exports.AllNonSaleVariants = AllNonSaleVariants;
//Returns all the variants for the product that are both available and on sale
var AllAvailableSaleVariants = function (product, template) {
    return product.variants.filter(function (v) {
        return template.isVariantOnSale(v) && template.isVariantAvailable(v);
    });
};
exports.AllAvailableSaleVariants = AllAvailableSaleVariants;
//Returns all the variants that are both available and NOT on sale
var AllAvailableNonSaleVariants = function (product, template) {
    return product.variants.filter(function (v) {
        return !template.isVariantOnSale(v) && template.isVariantAvailable(v);
    });
};
exports.AllAvailableNonSaleVariants = AllAvailableNonSaleVariants;
//# sourceMappingURL=All.js.map